'use client';

import { useIntl } from 'react-intl';

export type LegalHintsProps = {
  /**
   * defines the surcharge for a selected payment pause
   */
  paymentPauseValuta: number | null;
};

/**
 * legal hints atom
 *
 * atom to display the legal hints
 *
 * config installmentCalculator.useLegalHint defines whether it should used or not
 *
 * */
export const LegalHints = ({ paymentPauseValuta }: LegalHintsProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="text-size-body3 grid grid-cols-[auto_auto] gap-x-2 gap-y-1 lg:gap-x-1.5">
      {paymentPauseValuta !== null && paymentPauseValuta > 0 && (
        <>
          <div>*</div>
          <div>
            {formatMessage(
              {
                id: 'ic-atom-LegalHints-paymentPauseSurcharge',
                defaultMessage:
                  'Für die Zahlpause (erst in 4 Monaten bezahlen) wird ein zusätzlicher Aufschlag von {paymentPauseValuta}% auf den Warenwert berechnet.',
              },
              { paymentPauseValuta },
            )}
          </div>
        </>
      )}
      <div>**</div>
      <div>
        {formatMessage({
          id: 'ic-atom-LegalHints-basketHint',
          defaultMessage:
            'Bitte beachte, dass die Raten ohne Versandkosten und Speditionsaufschläge ausgewiesen sind. Deine Aufschläge kannst du im Warenkorb unter Prüfen & Bestellen einsehen.',
        })}
      </div>
    </div>
  );
};
